import { useState } from "react";
import styles from "./styles.module.css";
import Container from "../Container";
import Button from "../Button";
import ArrowLink from "../ArrowLink";
import Heading from "../Heading";
import Image from "next/image";
import Link from "next/link";
import { Search } from "../Icons";
import cn from "classnames";

const ResourcesFilter = ({ isActive, children, onClick = () => {} }) => {
  return (
    <span
      className={cn(styles.filter, { [styles.filterActive]: isActive })}
      onClick={onClick}
    >
      {children}
    </span>
  );
};

const ResourcesSearch = ({ setFilter, filter }) => {
  return (
    <div className={styles.filters}>
      <ResourcesFilter
        isActive={filter === null}
        onClick={() => setFilter(null)}
      >
        All Topics
      </ResourcesFilter>
      <ResourcesFilter
        isActive={filter === "blog"}
        onClick={() => setFilter("blog")}
      >
        Blog
      </ResourcesFilter>
      <ResourcesFilter
        isActive={filter === "report"}
        onClick={() => setFilter("report")}
      >
        Report
      </ResourcesFilter>
      <ResourcesFilter
        isActive={filter === "media"}
        onClick={() => setFilter("media")}
      >
        Media
      </ResourcesFilter>
      <ResourcesFilter
        isActive={filter === "speaking-engagement"}
        onClick={() => setFilter("speaking-engagement")}
      >
        Speaking Engagements
      </ResourcesFilter>
    </div>
  );
};

export default ResourcesSearch;
